export { FontAwesomeIcon as Icon } from "@fortawesome/react-native-fontawesome";
